/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  console.log("access.ts: ", initialState);
  const { currentUser } = initialState ?? {};
  return {
    //canAdmin:currentUser && currentUser.access === 'admin',
    canAdmin:true
  };
}
